import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator"; 
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator"; 


export class Jcksb { 
    @MaxLength(10,{message: 'COMPANY 字串太長'}) 
    @IsString({message: 'COMPANY 不是字串型態'}) 
    COMPANY: string = ''; 
  
    @MaxLength(10) 
    CREATOR: string = ''; 
  
    @MaxLength(10) 
    USR_GROUP: string = ''; 
  
    @MaxLength(8) 
    CREATE_DATE: string =''; 
  
    @MaxLength(10) 
    MODIFIER: string = ''; 
  
    @MaxLength(8) 
    MODI_DATE: string = ''; 
  
    @IsNumber() 
    @Max(999) 
    FLAG: number =0; 



}
